// extracted by mini-css-extract-plugin
module.exports = {"animated":"e_Xz","dots":"e_Yz"};